// @flow
import {CATEGORY} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

import type {ActiveFiltersType} from './activeFiltersType';

export const initialState: ActiveFiltersType = {};

/**
 * Get active filters
 *
 * @param {ActiveFiltersType} state  - Current state
 * @param {ActionType<ActiveFiltersType>} action - Received action
 * @returns {ActiveFiltersType} - active filter
 */
export default function activeFilters(
    state: ActiveFiltersType = initialState,
    action: ActionType<ActiveFiltersType>,
): ActiveFiltersType {
    switch (action.type) {
        case CATEGORY.SET_ACTIVE_FILTERS:
            return {...action.payload};
        case CATEGORY.REMOVE_ACTIVE_FILTERS:
            return {...initialState};
        default:
            return state;
    }
}
